import React, { FC, useEffect } from 'react';
import ReactModal from 'react-modal';

import { overridable } from '@24i/nxg-sdk-gluons/src/context/ComponentOverrides';
import { FULLSCREEN_MODAL_GAP } from '@24i/nxg-core-utils/src/constants';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { ThemeIcon, Interactable, Text } from '@24i/nxg-sdk-quarks';

import getModalStyles from '../styles/index.web';
import { ModalProps, MODAL_TEST_IDS } from '../types';
import { Breakpoint } from '../../../../utils/styles/constants';

const Modal: FC<ModalProps> = ({
    visible,
    styles: getStyles = getModalStyles,
    children,
    modalTitle,
    onRequestClose,
    animationType,
    transparent = true,
    overrideDisplayIcon = true,
    roundCloseButton,
    ...props
}) => {
    const { theme } = useTheme();
    const styles = getStyles(theme, transparent, animationType);
    const isTelegramWebApp = getTelegramWebApp();

    useEffect(() => {
        if (props?.name === 'search') {
            document.body.classList.replace(
                'ReactModal__Body--open',
                'ReactModal__Body--open__hidden'
            );
        } else {
            document.body.classList.remove('ReactModal__Body--open__hidden');
        }
    }, [props?.name]);

    return (
        <ReactModal
            testId="web-modal-test-id"
            style={{
                overlay: styles.overlay,
                content: styles.content,
            }}
            isOpen={visible}
            onRequestClose={onRequestClose}
            closeTimeoutMS={350}
            {...props}
        >
            <style global jsx>{`
                @media (max-width: ${Breakpoint.SM}px) {
                    .ReactModal__Body--open {
                        overflow: hidden;
                    }
                }
            `}</style>
            {
                // @ts-ignore
                !!modalTitle && <Text style={styles.title}>{modalTitle}</Text>
            }
            {overrideDisplayIcon && onRequestClose && (
                <Interactable
                    onPress={onRequestClose}
                    // @ts-ignore
                    style={[
                        styles.closeBtn,
                        !!roundCloseButton && styles.roundCloseBtn,
                        isTelegramWebApp && { top: FULLSCREEN_MODAL_GAP },
                    ]}
                    testID={MODAL_TEST_IDS.CLOSE_BUTTON}
                >
                    <ThemeIcon iconName="onPrimary-close" size={24} />
                </Interactable>
            )}
            {children}
        </ReactModal>
    );
};

export { getModalStyles };
export default overridable(Modal, 'Modal');
